module.exports = __webpack_public_path__ + "static/media/logo2.bfe11ed4.jpg";